export const START_SIGNING_ACTIONS = Object.freeze({
  NOW: 'now',
  SCHEDULED: 'scheduled',
  EDIT: 'edit',
})
